import React from "react";
import { Helmet } from "react-helmet-async";
import {
  GMB_FALLBACK_AGGREGATE_RATING,
  GMB_FALLBACK_RATING_COUNT,
} from "../../constants/gmb";
import { useGmbReviews } from "../../context/GmbReviewsContext";
import { buildLocalBusinessSchema } from "../../utils/gmbSchema";

export default function GmbStructuredData() {
  const { aggregateRating, ratingCount } = useGmbReviews();

  const structuredData = buildLocalBusinessSchema({
    aggregateRating: aggregateRating ?? GMB_FALLBACK_AGGREGATE_RATING,
    ratingCount: ratingCount ?? GMB_FALLBACK_RATING_COUNT,
  });

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
